var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgLogOut16X16 = function SvgLogOut16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.365 32h8.727a4.368 4.368 0 004.364-4.364v-5.818a1.454 1.454 0 10-2.91 0v5.818c0 .802-.652 1.455-1.454 1.455H4.365a1.456 1.456 0 01-1.455-1.455V4.364c0-.802.652-1.455 1.455-1.455h8.727c.802 0 1.454.653 1.454 1.455v5.818a1.454 1.454 0 102.91 0V4.364A4.368 4.368 0 0013.091 0H4.365A4.368 4.368 0 000 4.364v23.272A4.368 4.368 0 004.365 32z",
    fill: "#9CA6AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.728 16c0 .803.65 1.454 1.455 1.454h16.852L20.791 23.7a1.454 1.454 0 102.057 2.057l8.726-8.727a1.454 1.454 0 00.315-1.585 1.453 1.453 0 00-.315-.473l-8.726-8.727a1.454 1.454 0 10-2.057 2.057l6.244 6.244H10.183c-.804 0-1.455.652-1.455 1.455z",
    fill: "#9CA6AD"
  })));
};

export default SvgLogOut16X16;